<template>
    <header>
      <div class="header-content">
        <VCheckbox v-model="feedFilters.comment">
          Комментарии
        </VCheckbox>

        <VCheckbox v-model="feedFilters.changelog">
          События
        </VCheckbox>

        <VCheckbox v-model="feedFilters.notification">
          Уведомления
        </VCheckbox>
      </div>

      <div class="toolbar">
        <button
          type="button"
          @click="close"
        >
          <VIcon material="close"/>
        </button>
      </div>
    </header>

    <Feed
        ref="feed"
        :parent-entities="parentEntity"
        :feed-types="feedFiltersFormatted"
    />

    <footer>
      <VCommentCreateForm
          :parent-entity="parentEntity"
          @comment:created="renewData"
      />
    </footer>
</template>

<script lang="ts">
import EntityPointer from '@/domains/EntityPointer/EntityPointer';
import Feed          from './Feed/Feed.vue';

export default defineComponent({
  name: 'VFeedSection',

  components: {
    Feed,
  },

  props: {
    /** Указатель на сущность-родителя фида. */
    parentEntity: {
      type:     EntityPointer,
      required: true,
    },
  },

  emits: ['request-close'],

  data() {
    return {
      feedFilters: {
        comment:      true,
        changelog:    true,
        notification: true,
      },
    };
  },

  computed: {
    feedFiltersFormatted(): string[] {
      const { comment, changelog, notification } = this.feedFilters;
      const result: string[] = [];

      if (comment) { result.push('comment'); }
      if (changelog) { result.push('changelog'); }
      if (notification) { result.push('notification'); }

      return result;
    },
  },

  watch: {
    // Изменились фильтры — перезагружаем фид. Реагируем на сам факт
    // изменения набора типов, без обработчиков на каждом чекбоксе
    // (и без прежнего setTimeout, ждавшего обновления v-model).
    feedFiltersFormatted: {
      flush: 'post',
      handler() { this.renewData() }
    },
  },

  methods: {
    renewData() {
      this.$refs?.feed?.renewData();
    },

    close() {
      this.$parent.close();
    },
  },
});
</script>
